// Apre la mappa geolocalizzata ATTORNO all'utente (come "Cerca intorno a te").
// Condiviso dalla tab bar di Home / Mappa / Analizzati. 2026-07-14.
//
// IMPORTANTE: navighiamo SUBITO (apertura istantanea) e lasciamo che sia la mappa
// a geolocalizzare in background (?around=1) e ricentrarsi appena ha la posizione.
// Prima invece si aspettava getCurrentPosition (fino a ~1s) prima di navigare.
export function openMapAroundMe(navigate) {
  navigate('/app/mappa?around=1');
}
